import { FlyerLayoutAbstract } from './flyer-layout.abstract'
import moment from 'moment-timezone'

export default class Flyer_layout_split_t_039LayoutModel extends FlyerLayoutAbstract {
  flourishes = []

  textLayouts = {
    event_name_1: {
      top: 95,
      left: 25,
      size: 37,
      width: 270,
      height: 86.5,
      align: 'left'
    },
    location_1: {
      top: 455,
      right: 25,
      size: 16,
      width: 270,
      height: 19,
      align: 'right',
      nowrap: true
    },
    location_2: {
      top: 480,
      right: 25,
      size: 16,
      width: 270,
      height: 19,
      align: 'right',
      nowrap: true
    }
  }

  dateLayouts = {
    date_1: {
      top: 75,
      left: 25,
      daySize: 11,
      height: 13,
      lineHeight: 13,
      width: 270,
      align: 'left',
      nowrap: true
    }
  }

  constructor(flyerDesign, eventData) {
    super(flyerDesign, eventData)
    this.init()
  }

  getLocationText1() {
    const customName = this.eventData.custom_venue_name || ''
    const venueName = this.eventData.venue?.name || ''
    let formattedString = (customName.length > 0 || customName === '')
      ? customName
      : venueName || ''
    return formattedString.replace('(null)', '')
  }

  getLocationText2() {
    const street = this.eventData.venue?.street || ''
    const city = this.eventData.venue?.city || ''
    const state = this.eventData.venue?.state || ''
    const country = this.eventData.venue?.country || ''
    let formattedString = ''
    if (street) {
      formattedString = street
    } else if (city) {
      formattedString = `${city}, ${state}`
    } else if (state) {
      formattedString = `${state}, ${country}`
    } else {
      formattedString = country
    }
    return formattedString.replace('(null)', '')
  }

  dayShortSuffixForDate(date) {
    const d = moment(date).date()
    if (d > 3 && d < 21) return 'TH'
    switch (d % 10) {
      case 1: return 'ST'
      case 2: return 'ND'
      case 3: return 'RD'
      default: return 'TH'
    }
  }

  stripZerosForHour(timeStr) {
    return timeStr.replace(/^0+/, '')
  }

  getEventDateLabel({ eventStartDate, eventEndDate, eventTimeZone }) {
    if (!eventStartDate) return null

    const tz = eventTimeZone || 'UTC'
    const start = moment.tz(eventStartDate, tz)
    const end = eventEndDate ? moment.tz(eventEndDate, tz) : null

    let startTime = start.format('h:mma')
    let endTime = end ? end.format('h:mma') : null
    startTime = this.stripZerosForHour(startTime)
    if (endTime) endTime = this.stripZerosForHour(endTime)

    const startDay = start.format('dddd')
    const startMonthDay = start.format('MMMM D')
    const startDateStr = `${startDay}, ${startMonthDay}, ${startTime}`

    if (end) {
      const isSingleDay = start.isSame(end, 'day')
      if (isSingleDay) {
        return `${startDateStr} to ${endTime}`
      } else {
        const startShort = start.format('ddd, MMM D')
        const endShort = end.format('ddd, MMM D')
        return `${startShort} ${startTime} till ${endShort} ${endTime}`
      }
    } else {
      return startDateStr
    }
  }

  getDateTexts() {
    const startDate = this.eventData.starts_at
    const endDate = this.eventData.ends_at
    const timeZone = this.eventData.timezone || 'UTC'

    const { daySize, left, top, align, width, height, lineHeight, nowrap } = this.dateLayouts.date_1

    const safeDate1Color = this.dateProps.date1Props?.color?.replace('0x', '#') || '#cccccc'
    const safeDate1Font = this.dateProps.date1Props?.font?.replace(/\s+/g, '-') || 'Arial'

    let dates = []
    let textTop = top

    if (!startDate) return { type: 'date', dates }

    const text = this.getEventDateLabel({ eventStartDate: startDate, eventEndDate: endDate, eventTimeZone: timeZone })
    dates.push({
      text,
      align,
      width,
      height,
      left,
      lineHeight,
      top: textTop,
      color: safeDate1Color,
      font: safeDate1Font,
      size: daySize,
      nowrap
    })

    return { type: 'date', dates }
  }
}
